import React from "react";
import CommonRow from "../common-row";

const FourteenStories3Ad1Widget = props => {
  return <CommonRow {...props} />;
};

export default FourteenStories3Ad1Widget;
